// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.join-page {
    background: #ffffff;
}

.join-hero {
    position: relative;
    overflow: hidden;
    min-height: 52vh;
    display: flex;
    align-items: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),
        #0d0d10;
    color: #ffffff;
}

.join-hero-bg {
    position: absolute;
    inset: 0;
}

.join-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: joinGridMove 24s linear infinite;
}

.join-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),
        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);
}

.join-hero-content {
    position: relative;
    z-index: 1;
    padding-top: 132px;
    padding-bottom: 72px;
}

.join-kicker,
.join-page-tag,
.join-contact-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.join-hero-title {
    margin: 18px 0 14px;
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    line-height: 1.04;
}

.join-hero-description {
    max-width: 760px;
    color: rgba(255, 255, 255, 0.84);
    font-size: 1.04rem;
    line-height: 1.8;
}

.join-main-section {
    padding-top: 48px;
    padding-bottom: 56px;
}

.join-page-intro,
.join-role-card,
.join-contact-panel,
.join-status-card {
    border-radius: 24px;
    border: 1px solid rgba(217, 0, 27, 0.08);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #faf7f7 100%);
    box-shadow: 0 18px 40px rgba(22, 22, 26, 0.05);
}

.join-page-intro,
.join-role-card,
.join-contact-panel,
.join-status-card {
    padding: 28px;
}

.join-page-intro {
    margin-bottom: 24px;
}

.join-page-intro h2,
.join-role-card h2 {
    margin: 12px 0 10px;
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    line-height: 1.15;
}

.join-page-intro p,
.join-role-card p,
.join-contact-description,
.join-requirement-card p,
.join-paragraph-stack p,
.join-status-card p,
.join-position-chip small {
    color: var(--text-light);
    line-height: 1.64;
}

.join-status-card.is-error {
    border-color: rgba(217, 0, 27, 0.16);
    background: linear-gradient(180deg, #fff9f9 0%, #fff2f4 100%);
}

.join-status-card h3 {
    margin-bottom: 8px;
    font-size: 1.24rem;
}

.join-switcher-panel {
    display: grid;
    gap: 16px;
    margin-bottom: 28px;
    padding: 0 0 22px;
    border-bottom: 1px solid rgba(217, 0, 27, 0.08);
}

.section-header {
    display: grid;
    gap: 8px;
}

.section-subtitle {
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.section-title {
    font-size: 1.5rem;
    line-height: 1.2;
}

.join-position-switcher {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 12px;
}

.join-position-chip {
    min-width: 0;
    padding: 12px 16px;
    border-radius: 14px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: transparent;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 10px 12px;
    align-items: start;
    text-align: left;
    transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;
}

.join-position-chip:hover {
    transform: translateY(-1px);
    border-color: rgba(217, 0, 27, 0.22);
    box-shadow: 0 10px 24px rgba(217, 0, 27, 0.08);
}

.join-position-chip.is-active {
    border-color: rgba(217, 0, 27, 0.28);
    background: rgba(255, 247, 248, 0.75);
}

.join-position-chip span {
    display: inline-flex;
    align-items: center;
    align-self: start;
    width: fit-content;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(217, 0, 27, 0.06);
    color: var(--accent-red);
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.join-position-chip-copy {
    display: grid;
    gap: 2px;
    min-width: 0;
}

.join-position-chip strong {
    font-size: 1rem;
    line-height: 1.4;
    color: var(--text-main);
}

.join-position-chip small {
    font-size: 0.92rem;
}

.join-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 24px;
    align-items: start;
}

.join-content {
    min-width: 0;
    display: block;
}

.join-role-meta {
    margin-top: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px;
    font-size: 0.86rem;
    line-height: 1.5;
}

.join-role-meta span {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--text-light);
}

.join-role-meta strong {
    font-size: 0.82rem;
    font-weight: 500;
    color: var(--text-main);
}

.join-role-sections {
    display: grid;
    gap: 26px;
    margin-top: 26px;
    padding-top: 26px;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.join-rich-section {
    display: grid;
    gap: 16px;
    padding: 0;
    margin: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
}

.join-rich-section .section-header {
    margin-bottom: 0;
    display: grid;
    gap: 6px;
    align-items: start;
}

.join-rich-section .section-title {
    font-size: 1.28rem;
    margin: 0;
}

.join-paragraph-stack {
    display: grid;
    gap: 8px;
}

.join-requirement-list {
    display: grid;
    gap: 0;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.join-requirement-item {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr);
    gap: 18px;
    align-items: start;
    padding: 18px 0;
    border-bottom: 1px solid rgba(217, 0, 27, 0.08);
}

.join-requirement-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    min-width: 68px;
    padding: 7px 0;
    border-radius: 999px;
    background: rgba(217, 0, 27, 0.06);
    color: var(--accent-red);
    font-size: 0.84rem;
    font-weight: 800;
    letter-spacing: 0.08em;
}

.join-requirement-item h4 {
    margin: 0 0 6px;
    font-size: 1.06rem;
    line-height: 1.35;
    color: var(--text-main);
}

.join-requirement-copy {
    min-width: 0;
    max-width: 760px;
}

.join-requirement-item p {
    margin: 0;
}

.join-contact-panel {
    position: sticky;
    top: 110px;
    display: grid;
    gap: 18px;
}

.join-contact-panel h3 {
    font-size: 1.5rem;
    line-height: 1.2;
}

.join-contact-details {
    display: grid;
    gap: 0;
    border-top: 1px solid rgba(217, 0, 27, 0.08);
}

.join-contact-row {
    display: grid;
    gap: 6px;
    padding: 14px 0;
    border-bottom: 1px solid rgba(217, 0, 27, 0.08);
}

.join-contact-row span {
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--text-light);
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

.join-contact-row a {
    font-size: 1.06rem;
    font-weight: 700;
    color: var(--text-main);
    word-break: break-all;
}

.join-contact-row a:hover {
    color: var(--accent-red);
}

.join-qr-block {
    display: grid;
    grid-template-columns: 132px minmax(0, 1fr);
    gap: 16px;
    align-items: center;
    padding-top: 4px;
}

.join-qr-visual {
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-radius: 16px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(217, 0, 27, 0.12);
}

.join-qr-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
    display: block;
}

.join-qr-copy {
    display: grid;
    gap: 6px;
}

.join-qr-copy strong {
    color: var(--text-main);
    font-size: 1rem;
}

.join-qr-copy span {
    color: var(--text-light);
    font-size: 0.92rem;
}

@keyframes joinGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@media (max-width: 1080px) {
    .join-layout {
        grid-template-columns: 1fr;
    }

    .join-contact-panel {
        position: static;
    }
}

@media (max-width: 768px) {
    .join-hero-content {
        padding-top: 118px;
        padding-bottom: 60px;
    }

    .join-main-section {
        padding-top: 38px;
        padding-bottom: 40px;
    }

    .join-page-intro,
    .join-role-card,
    .join-contact-panel,
    .join-status-card {
        padding: 18px;
        border-radius: 18px;
    }

    .join-switcher-panel {
        margin-bottom: 22px;
        padding-bottom: 18px;
    }

    .join-position-switcher {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .join-position-chip {
        padding: 13px 14px;
        border-radius: 14px;
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .join-role-sections {
        margin-top: 20px;
        padding-top: 20px;
        gap: 18px;
    }

    .join-requirement-item {
        grid-template-columns: 1fr;
        gap: 10px;
        padding: 16px 0;
    }

    .join-requirement-index {
        min-width: 60px;
    }

    .join-qr-block {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .join-qr-visual {
        width: min(220px, 100%);
        margin: 0 auto;
    }
}

.join-qr-visual span {
  color: var(--text-light);
  text-align: center;
  line-height: 1.7;
}
`, "",{"version":3,"sources":["webpack://./src/styles/join-future-world.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;;;IAII,mBAAmB;IACnB,wCAAwC;IACxC,+EAA+E;IAC/E,8CAA8C;AAClD;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;;;;;;;IAOI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,uBAAuB;IACvB,aAAa;IACb,0CAA0C;IAC1C,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kCAAkC;IAClC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,MAAM;IACN,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,kCAAkC;IAClC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;;;;QAII,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;AACJ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".join-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.join-hero {\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 52vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.join-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.join-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: joinGridMove 24s linear infinite;\r\n}\r\n\r\n.join-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),\r\n        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);\r\n}\r\n\r\n.join-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding-top: 132px;\r\n    padding-bottom: 72px;\r\n}\r\n\r\n.join-kicker,\r\n.join-page-tag,\r\n.join-contact-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: fit-content;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.join-hero-title {\r\n    margin: 18px 0 14px;\r\n    font-size: clamp(2.5rem, 5vw, 4.5rem);\r\n    line-height: 1.04;\r\n}\r\n\r\n.join-hero-description {\r\n    max-width: 760px;\r\n    color: rgba(255, 255, 255, 0.84);\r\n    font-size: 1.04rem;\r\n    line-height: 1.8;\r\n}\r\n\r\n.join-main-section {\n    padding-top: 48px;\n    padding-bottom: 56px;\n}\n\n.join-page-intro,\n.join-role-card,\n.join-contact-panel,\n.join-status-card {\n    border-radius: 24px;\n    border: 1px solid rgba(217, 0, 27, 0.08);\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #faf7f7 100%);\n    box-shadow: 0 18px 40px rgba(22, 22, 26, 0.05);\n}\n\n.join-page-intro,\n.join-role-card,\n.join-contact-panel,\n.join-status-card {\n    padding: 28px;\n}\n\r\n.join-page-intro {\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.join-page-intro h2,\r\n.join-role-card h2 {\r\n    margin: 12px 0 10px;\r\n    font-size: clamp(1.8rem, 3vw, 2.6rem);\r\n    line-height: 1.15;\r\n}\r\n\r\n.join-page-intro p,\n.join-role-card p,\n.join-contact-description,\n.join-requirement-card p,\n.join-paragraph-stack p,\n.join-status-card p,\n.join-position-chip small {\n    color: var(--text-light);\n    line-height: 1.64;\n}\n\r\n.join-status-card.is-error {\r\n    border-color: rgba(217, 0, 27, 0.16);\r\n    background: linear-gradient(180deg, #fff9f9 0%, #fff2f4 100%);\r\n}\r\n\r\n.join-status-card h3 {\n    margin-bottom: 8px;\n    font-size: 1.24rem;\n}\n\n.join-switcher-panel {\n    display: grid;\n    gap: 16px;\n    margin-bottom: 28px;\n    padding: 0 0 22px;\n    border-bottom: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.section-header {\n    display: grid;\n    gap: 8px;\n}\r\n\r\n.section-subtitle {\r\n    font-size: 0.8rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.section-title {\r\n    font-size: 1.5rem;\r\n    line-height: 1.2;\r\n}\r\n\n.join-position-switcher {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 12px;\n}\n\n.join-position-chip {\n    min-width: 0;\n    padding: 12px 16px;\n    border-radius: 14px;\n    border: 1px solid rgba(217, 0, 27, 0.1);\n    background: transparent;\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    gap: 10px 12px;\n    align-items: start;\n    text-align: left;\n    transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;\n}\n\n.join-position-chip:hover {\n    transform: translateY(-1px);\n    border-color: rgba(217, 0, 27, 0.22);\n    box-shadow: 0 10px 24px rgba(217, 0, 27, 0.08);\n}\n\n.join-position-chip.is-active {\n    border-color: rgba(217, 0, 27, 0.28);\n    background: rgba(255, 247, 248, 0.75);\n}\n\n.join-position-chip span {\n    display: inline-flex;\n    align-items: center;\n    align-self: start;\n    width: fit-content;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: rgba(217, 0, 27, 0.06);\n    color: var(--accent-red);\n    font-size: 0.74rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.join-position-chip-copy {\n    display: grid;\n    gap: 2px;\n    min-width: 0;\n}\n\n.join-position-chip strong {\n    font-size: 1rem;\n    line-height: 1.4;\n    color: var(--text-main);\n}\n\n.join-position-chip small {\n    font-size: 0.92rem;\n}\n\n.join-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 360px;\r\n    gap: 24px;\r\n    align-items: start;\r\n}\r\n\r\n.join-content {\r\n    min-width: 0;\r\n    display: block;\r\n}\r\n\r\n.join-role-meta {\n    margin-top: 18px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 4px;\n    font-size: 0.86rem;\n    line-height: 1.5;\n}\n\n.join-role-meta span {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: var(--text-light);\n}\n\n.join-role-meta strong {\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: var(--text-main);\n}\n\r\n.join-role-sections {\n    display: grid;\n    gap: 26px;\n    margin-top: 26px;\n    padding-top: 26px;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\r\n.join-rich-section {\r\n    display: grid;\r\n    gap: 16px;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    border-radius: 0;\r\n    background: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n.join-rich-section .section-header {\r\n    margin-bottom: 0;\r\n    display: grid;\r\n    gap: 6px;\r\n    align-items: start;\r\n}\r\n\r\n.join-rich-section .section-title {\r\n    font-size: 1.28rem;\r\n    margin: 0;\r\n}\r\n\r\n.join-paragraph-stack {\n    display: grid;\n    gap: 8px;\n}\n\n.join-requirement-list {\n    display: grid;\n    gap: 0;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.join-requirement-item {\n    display: grid;\n    grid-template-columns: 92px minmax(0, 1fr);\n    gap: 18px;\n    align-items: start;\n    padding: 18px 0;\n    border-bottom: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.join-requirement-index {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    min-width: 68px;\n    padding: 7px 0;\n    border-radius: 999px;\n    background: rgba(217, 0, 27, 0.06);\n    color: var(--accent-red);\n    font-size: 0.84rem;\n    font-weight: 800;\n    letter-spacing: 0.08em;\n}\n\n.join-requirement-item h4 {\n    margin: 0 0 6px;\n    font-size: 1.06rem;\n    line-height: 1.35;\n    color: var(--text-main);\n}\n\n.join-requirement-copy {\n    min-width: 0;\n    max-width: 760px;\n}\n\n.join-requirement-item p {\n    margin: 0;\n}\n\n.join-contact-panel {\n    position: sticky;\n    top: 110px;\n    display: grid;\n    gap: 18px;\n}\n\n.join-contact-panel h3 {\n    font-size: 1.5rem;\n    line-height: 1.2;\n}\n\n.join-contact-details {\n    display: grid;\n    gap: 0;\n    border-top: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.join-contact-row {\n    display: grid;\n    gap: 6px;\n    padding: 14px 0;\n    border-bottom: 1px solid rgba(217, 0, 27, 0.08);\n}\n\n.join-contact-row span {\n    font-size: 0.82rem;\n    font-weight: 700;\n    color: var(--text-light);\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n}\n\n.join-contact-row a {\n    font-size: 1.06rem;\n    font-weight: 700;\n    color: var(--text-main);\n    word-break: break-all;\n}\n\n.join-contact-row a:hover {\n    color: var(--accent-red);\n}\n\n.join-qr-block {\n    display: grid;\n    grid-template-columns: 132px minmax(0, 1fr);\n    gap: 16px;\n    align-items: center;\n    padding-top: 4px;\n}\n\n.join-qr-visual {\n    aspect-ratio: 1 / 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n    border-radius: 16px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.92);\n    border: 1px solid rgba(217, 0, 27, 0.12);\n}\n\r\n.join-qr-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n    border-radius: 12px;\r\n    display: block;\r\n}\r\n\r\n.join-qr-copy {\r\n    display: grid;\r\n    gap: 6px;\r\n}\r\n\r\n.join-qr-copy strong {\r\n    color: var(--text-main);\r\n    font-size: 1rem;\r\n}\r\n\r\n.join-qr-copy span {\r\n    color: var(--text-light);\r\n    font-size: 0.92rem;\r\n}\r\n\r\n@keyframes joinGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@media (max-width: 1080px) {\r\n    .join-layout {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .join-contact-panel {\r\n        position: static;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\n    .join-hero-content {\n        padding-top: 118px;\n        padding-bottom: 60px;\n    }\r\n\r\n    .join-main-section {\r\n        padding-top: 38px;\r\n        padding-bottom: 40px;\r\n    }\r\n\n    .join-page-intro,\n    .join-role-card,\n    .join-contact-panel,\n    .join-status-card {\n        padding: 18px;\n        border-radius: 18px;\n    }\n\n    .join-switcher-panel {\n        margin-bottom: 22px;\n        padding-bottom: 18px;\n    }\n\n    .join-position-switcher {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .join-position-chip {\n        padding: 13px 14px;\n        border-radius: 14px;\n        grid-template-columns: 1fr;\n        gap: 8px;\n    }\n\n    .join-role-sections {\n        margin-top: 20px;\n        padding-top: 20px;\n        gap: 18px;\n    }\n\n    .join-requirement-item {\n        grid-template-columns: 1fr;\n        gap: 10px;\n        padding: 16px 0;\n    }\n\n    .join-requirement-index {\n        min-width: 60px;\n    }\n\n    .join-qr-block {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n\n    .join-qr-visual {\n        width: min(220px, 100%);\n        margin: 0 auto;\n    }\n}\n\r\n.join-qr-visual span {\r\n  color: var(--text-light);\r\n  text-align: center;\r\n  line-height: 1.7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
